export const GetAutoMVsPendingCalific = async function (thiss) {
  let tableData = [];
  await thiss.$http
    .get(
      `/api/CMI/AutoMVs/GetAutoMVsPendingCalific?currentUser=${thiss.currentUser.EmployeeId}`
    )
    .then((resp) => {
      // console.log("GetAutoMVsByOwner resp: ", resp);
      tableData = resp.data;
    })
    .catch((err) => {
      console.error("Error en GetAutoMVsByOwner: ", err);
    });
  return tableData;
};
